import { ImageModule } from '#components/Image/ImageModule';
import { IconSystemButton } from '#components/base/IconButton/IconSystemButton';
import { LightGallery } from '#components/base/LightGallery/LightGallery';
import { MediaContextPlaybackStatus } from '#cutils/context/MediaContext';
import { logger } from '#utils/logging/logger';

import styles from './ArticleModuleImage.module.scss';
import { ArticleModuleMediaCollapsibleMetadataBox } from './ArticleModuleMediaCollapsibleMetadataBox';
import { ARTICLE_MODULE_MEDIA_IMAGE_SIZES } from './ArticleModuleMediaSize';
import sectionStyles from './SectionStyles.module.scss';
import type { ArticleModuleImageFragment } from './__generated__/ArticleModuleImage.generated';

type Props = {
	imageModule: ArticleModuleImageFragment;
};

function getImageHref(url: string | null | undefined) {
	if (!url) {
		return undefined;
	}
	try {
		const parsedURL = new URL(url);
		parsedURL.searchParams.set('w', '1024');

		return parsedURL.toString();
	} catch {
		return url;
	}
}

export function ArticleModuleImage({ imageModule }: Props) {
	const thumbnail = imageModule.thumbnail;

	if (!thumbnail) {
		logger.error(`No thumbnail for image module with '%s' found`, imageModule.rowId);

		return null;
	}

	const collapsibleMetadataBox = (
		<ArticleModuleMediaCollapsibleMetadataBox
			articleModule={imageModule}
			mediaPlaybackStatus={MediaContextPlaybackStatus.STOPPED}
			moduleType={imageModule.type}
		/>
	);

	const image = (
		<a href={getImageHref(thumbnail.url)} data-sub-html={`<p>${thumbnail.title} <br />Bildrechte: ${imageModule.copyright}</p>`}>
			<ImageModule image={thumbnail} sizes={ARTICLE_MODULE_MEDIA_IMAGE_SIZES} />
			<IconSystemButton className={styles.zoomIconRoot} type="primary" variant="filled" size="s" icon="scale-bigger">
				<span className="srOnly">Bild vergrößern</span>
			</IconSystemButton>
		</a>
	);

	return (
		<section className={`${styles.wrapper} ${sectionStyles.section}`}>
			<LightGallery speed={500} download={false} counter={false} mobileSettings={{ showCloseIcon: true }}>
				{image}
			</LightGallery>

			{collapsibleMetadataBox}
		</section>
	);
}
